import React from 'react'
import styled from 'styled-components'
import { enUS, pt, zhCN } from 'date-fns/locale'
import { formatTime } from './utils'

import { Link } from 'components/Common'

import { setStyledAccentColor } from 'utils/helpers'
import { media } from 'utils'
import { FormattedMessage } from 'react-intl'

const isChinaDeploy = process.env.GATSBY_CHINA_DEPLOY

const locales = {
  en: enUS,
  pt,
  zh: zhCN,
}

function EventCard(props) {
  /** we don't need lang prop, but don't want it in rest neither */
  const {
    content,
    heading = 'h4',
    noHeading,
    locale: lang = 'en',
    lang: _,
    no_location = false,
    toggleModalVisibility,
    ...rest
  } = props
  const locale = locales[lang.replace('default', 'en')]

  /* Methods */
  function triggerChinaEventAnalytics() {
    // baidu
    if (typeof window._hmt === 'function') {
      window._hmt.push(['_trackEvent', 'Button', 'PIE', 'Click'])
    }

    // symphony
    if (typeof window.XmoTag15443 === 'function') {
      window.XmoTag15443()
    }
  }

  const handleToggleModalVisibility = ev => {
    ev.preventDefault()
    toggleModalVisibility(props.uuid)
  }

  const date = content.date && new Date(content.date.replace(/-/g, '/'))

  const renderButton = () => {
    const singUpForm = content.signup_form
    const specificProps = {
      blok: { url: content.signup_link },
    }
    if (singUpForm && singUpForm.length > 0) {
      specificProps.blok = { url: { url: '#' } }
      specificProps.onClick = handleToggleModalVisibility
    }
    return (
      <Link
        {...specificProps}
        type="primaryButtonStyle"
        withArrow
        size="standard"
        css="margin: 41px 0 0 0; position: relative;"
      >
        <FormattedMessage id="register" />
        {isChinaDeploy && (
          <HiddenEventButton onClick={triggerChinaEventAnalytics} />
        )}
      </Link>
    )
  }

  return (
    <>
      <EventContent {...rest}>
        {!noHeading && <Title as={heading}>{content.name}</Title>}
        <div className="details">
          <Flex>
            <EventP>
              <FormattedMessage id="date" />
            </EventP>
            <EventContentP>
              {date && formatTime(date, 'PPP', locale)}
            </EventContentP>
            {/* <EventContentP>{content.display_date}</EventContentP> */}
          </Flex>
          <Flex>
            <EventP>
              <FormattedMessage id="time" />
            </EventP>
            <EventContentP>
              {date && formatTime(date, 'p', locale)}
              {content.date_end &&
              ' - ' + formatTime(new Date(content.date_end.replace(/-/g, '/')), 'p', locale)}
            </EventContentP>
          </Flex>
          {!no_location && (
            <Flex>
              <EventP>
                <FormattedMessage id="location" />
              </EventP>
              <EventContentP>{content.location}</EventContentP>
            </Flex>
          )}
          {renderButton()}
        </div>
      </EventContent>
    </>
  )
}

export default React.memo(EventCard)

export const EventContent = styled.div`
  padding: 80px 45px 0 30px;
  background-color: #fff;
  outline: none;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;

  ${media.greaterThan('350px')`
    padding: 80px 45px 0 30px;
  `}
  ${media.greaterThan('450px')`
    padding: 80px 50px 0 55px;
  `}
  ${media.greaterThan('770px')`
    padding: 80px 50px 0 44px;
  `}
  ${media.greaterThan('lg')`
    padding: 70px 30px 0 97px;
    margin-top: 70px;
  `}
`
export const Title = styled.h5`
  position: relative;
  margin-bottom: 60px;
  &:after {
    content: "";
    position: absolute;
    width: 58px;
    height: 6px;
    bottom: -27px;
    left: 0;
    background-color: ${setStyledAccentColor};
  }
`
export const EventP = styled.p`
  min-width: 90px;
  color: ${({ theme }) => theme.colors.dark};
`
export const EventContentP = styled.p`
  font-weight: 400;
`
export const Flex = styled.div`
  display: flex;
`

const HiddenEventButton = styled.button`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
`
